import React from 'react';
import { Link } from 'react-router-dom';
import {
    PRIORITY_LABELS,
    STATUS_LABELS,
    TYPE_LABELS,
} from '../helpers';

export const DashboardMainChartsGrid = ({
    dashboard,
    trendSeries,
    trendPoints,
    statusTotal,
    priorityTotal,
    typeTotal,
    formatNumber,
}) => {
    return (
        <div className="row g-3">
            <div className="col-12 col-xl-6">
                <div className="card card-body h-100">
                    <h6 className="mb-3">Tickets por estatus</h6>
                    {(dashboard?.tickets?.byStatus || []).map((item) => {
                        const percentage = statusTotal > 0 ? (Number(item.total || 0) / statusTotal) * 100 : 0;
                        return (
                            <div key={item.key} className="mb-2">
                                <div className="d-flex justify-content-between fs-12 mb-1">
                                    <span>{STATUS_LABELS[item.key] || item.key}</span>
                                    <span>{formatNumber(item.total)}</span>
                                </div>
                                <div className="progress" style={{ height: '8px' }}>
                                    <div className="progress-bar bg-primary" style={{ width: `${percentage}%` }} />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="col-12 col-xl-6">
                <div className="card card-body h-100">
                    <h6 className="mb-3">Tendencia de tickets creados</h6>
                    {trendSeries.length > 0 ? (
                        <>
                            <svg viewBox="0 0 100 100" preserveAspectRatio="none" style={{ width: '100%', height: '180px' }}>
                                <defs>
                                    <linearGradient id="trendFill" x1="0" y1="0" x2="0" y2="1">
                                        <stop offset="0%" stopColor="currentColor" stopOpacity="0.24" />
                                        <stop offset="100%" stopColor="currentColor" stopOpacity="0.02" />
                                    </linearGradient>
                                </defs>
                                <polygon
                                    fill="url(#trendFill)"
                                    points={`0,100 ${trendPoints} 100,100`}
                                    className="text-primary"
                                />
                                <polyline
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    className="text-primary"
                                    points={trendPoints}
                                />
                            </svg>
                            <div className="d-flex justify-content-between fs-11 text-muted mt-2">
                                <span>{trendSeries[0]?.date || '-'}</span>
                                <span>{trendSeries[trendSeries.length - 1]?.date || '-'}</span>
                            </div>
                        </>
                    ) : (
                        <div className="text-muted fs-13">Sin datos para el rango seleccionado.</div>
                    )}
                </div>
            </div>

            <div className="col-12 col-xl-6">
                <div className="card card-body h-100">
                    <h6 className="mb-3">Tickets por prioridad</h6>
                    {(dashboard?.tickets?.byPriority || []).map((item) => {
                        const percentage = priorityTotal > 0 ? (Number(item.total || 0) / priorityTotal) * 100 : 0;
                        return (
                            <div key={item.key} className="mb-2">
                                <div className="d-flex justify-content-between fs-12 mb-1">
                                    <span>{PRIORITY_LABELS[item.key] || item.key}</span>
                                    <span>{formatNumber(item.total)}</span>
                                </div>
                                <div className="progress" style={{ height: '8px' }}>
                                    <div className="progress-bar bg-warning" style={{ width: `${percentage}%` }} />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="col-12 col-xl-6">
                <div className="card card-body h-100">
                    <h6 className="mb-3">Tickets por tipo</h6>
                    {(dashboard?.tickets?.byType || []).map((item) => {
                        const percentage = typeTotal > 0 ? (Number(item.total || 0) / typeTotal) * 100 : 0;
                        return (
                            <div key={item.key} className="mb-2">
                                <div className="d-flex justify-content-between fs-12 mb-1">
                                    <span>{TYPE_LABELS[item.key] || item.key}</span>
                                    <span>{formatNumber(item.total)}</span>
                                </div>
                                <div className="progress" style={{ height: '8px' }}>
                                    <div className="progress-bar bg-info" style={{ width: `${percentage}%` }} />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="col-12 col-xl-6">
                <div className="card card-body h-100">
                    <h6 className="mb-3">Top proyectos con más tickets</h6>
                    <div className="table-responsive">
                        <table className="table table-sm align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>Proyecto</th>
                                    <th>Código</th>
                                    <th className="text-end">Tickets</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(dashboard?.tickets?.topProjects || []).length === 0 && (
                                    <tr>
                                        <td colSpan={3} className="text-center text-muted py-3">Sin datos para mostrar.</td>
                                    </tr>
                                )}
                                {(dashboard?.tickets?.topProjects || []).map((project) => (
                                    <tr key={project.projectId}>
                                        <td>
                                            {project?.projectId ? (
                                                <Link
                                                    to={`/project/detail/${project.projectId}`}
                                                    state={{ projectName: project?.name || '' }}
                                                    className="dashboard-project-link"
                                                >
                                                    {project.name || '-'}
                                                </Link>
                                            ) : (
                                                project.name || '-'
                                            )}
                                        </td>
                                        <td>
                                            {project?.projectId ? (
                                                <Link
                                                    to={`/project/detail/${project.projectId}`}
                                                    state={{ projectName: project?.name || '' }}
                                                    className="dashboard-project-link dashboard-project-link--code"
                                                >
                                                    {project.code || '-'}
                                                </Link>
                                            ) : (
                                                project.code || '-'
                                            )}
                                        </td>
                                        <td className="text-end fw-semibold">{formatNumber(project.total)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};
